import { ArrowUpRight } from "lucide-react";
import { SITE } from "@/data/site";

const QUOTES = [
  {
    text:
      "Me and my partner are not great on camera and were worried about feeling self-conscious. Alex and Ellis really made us feel at ease — throughout the day we barely noticed them there.",
    name: "Georgia",
    source: "Guides for Brides",
    url: "https://guidesforbrides.co.uk/wedding-videographers-and-video/essex/wedding-video-essex/165670",
  },
  {
    text:
      "I was very nervous about being filmed. Alex and Ellis filmed our day and it was the best decision we made. We barely noticed them around filming, they were so discreet.",
    name: "Sophie MacDonald",
    source: "Facebook",
    url: "https://www.facebook.com/essexweddingvideo/reviews",
  },
];

export default function CameraShy() {
  return (
    <section
      data-testid="camera-shy-section"
      className="py-28 md:py-40 bg-[#F5F0EA] relative grain overflow-hidden"
    >
      <div className="max-w-[1240px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-[1fr_1.1fr] gap-x-20 gap-y-14 items-start">
          <div>
            <p className="overline mb-7">For camera-shy couples</p>
            <h2 className="font-serif text-[2.6rem] sm:text-[3.4rem] md:text-[4.2rem] leading-[1.04] tracking-tight text-stone-900">
              Nervous on camera?
              <br />
              <em className="italic font-normal text-stone-600">
                So were most of our couples.
              </em>
            </h2>
            <p className="mt-8 font-serif text-stone-700 text-[1.15rem] leading-[1.7] max-w-xl">
              &ldquo;They made us feel at ease&rdquo; is the single most repeated
              phrase across our reviews — more than the films, more than the awards.
              We film calmly and unobtrusively, blending in like guests, so your day
              feels natural and you forget the cameras are even there.
            </p>
            <a
              href={SITE.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="link-elegant mt-9 text-base inline-flex"
              data-testid="camera-shy-cta"
            >
              Talk to Alex about your day
              <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>

          <div className="space-y-10 lg:pt-16">
            {QUOTES.map((q, i) => (
              <figure
                key={i}
                data-testid={`camera-shy-quote-${i}`}
                className="bg-white/70 backdrop-blur px-8 py-8 md:px-10 md:py-9"
              >
                <blockquote className="font-serif italic text-stone-800 text-[1.2rem] md:text-[1.3rem] leading-[1.55]">
                  &ldquo;{q.text}&rdquo;
                </blockquote>
                <figcaption className="mt-5 font-serif text-stone-500">
                  {q.name} ·{" "}
                  <a
                    href={q.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline underline-offset-4 hover:text-stone-800 transition-colors"
                    data-testid={`camera-shy-quote-source-${i}`}
                  >
                    verified on {q.source}
                  </a>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
